import { Panel, PanelInset, Table, TableTbody, TableTh, TableThead, TableTr } from '@customerio/pluma-components/react';
import type { Webhook } from '@/services/db/webhook/entity';
import { ReportingWebhookRow } from './reporting-webhook-row';

// Ember sizes the three columns 9/12, 2/12, 1/12.
const NAME_COLUMN_WIDTH = 'calc((9 / 12) * 100%)';
const STATE_COLUMN_WIDTH = 'calc((2 / 12) * 100%)';
const ACTIONS_COLUMN_WIDTH = 'calc((1 / 12) * 100%)';

type ReportingWebhooksTableProps = {
  webhooks: Webhook[];
  editHref: (id: string) => string;
  canEdit: boolean;
  canDelete: boolean;
};

export function ReportingWebhooksTable({ webhooks, editHref, canEdit, canDelete }: ReportingWebhooksTableProps) {
  const enabledCount = webhooks.filter((webhook) => webhook.enabled).length;

  return (
    <Panel mt="300">
      <PanelInset>
        <Table caption="Your list of webhooks" data-test-webhook-list>
          <TableThead>
            <TableTr>
              <TableTh style={{ width: NAME_COLUMN_WIDTH }}>Webhook</TableTh>
              <TableTh style={{ width: STATE_COLUMN_WIDTH }} textAlign="center">
                State
              </TableTh>
              <TableTh style={{ width: ACTIONS_COLUMN_WIDTH }} textAlign="right">
                Actions
              </TableTh>
            </TableTr>
          </TableThead>
          <TableTbody>
            {webhooks.map((webhook) => (
              <ReportingWebhookRow
                key={webhook.id}
                webhook={webhook}
                editHref={editHref(webhook.id)}
                canEdit={canEdit}
                canDelete={canDelete}
                isLastEnabled={webhook.enabled && enabledCount === 1}
                isOnlyWebhook={webhooks.length === 1}
              />
            ))}
          </TableTbody>
        </Table>
      </PanelInset>
    </Panel>
  );
}
